import { render, staticRenderFns } from "./CustomVideoOverlays.vue?vue&type=template&id=b8b5fd72&scoped=true&"
import script from "./CustomVideoOverlays.vue?vue&type=script&lang=js&"
export * from "./CustomVideoOverlays.vue?vue&type=script&lang=js&"
import style0 from "./CustomVideoOverlays.vue?vue&type=style&index=0&id=b8b5fd72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b5fd72",
  null
  
)

export default component.exports